module.exports = __webpack_public_path__ + "static/media/ai.539fef65.svg";